/**
 * App - Root component with React Router.
 */

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import AgentApp from "./pages/AgentApp";
import ServicePage from "./pages/ServicePage";
import LocalNotesTestPage from "./pages/LocalNotesTestPage";
import NotesPopoutPage from "./pages/NotesPopoutPage";
import NotepadTestPage from "./pages/NotepadTestPage";
import { AppContextProvider } from "./contexts/AppContext";
import type { AppConfig } from "./lib/config";

interface AppProps {
  config: AppConfig;
}

export default function App({ config }: AppProps) {
  return (
    <ErrorBoundary>
      <AppContextProvider config={config}>
        <BrowserRouter>
          <Routes>
            {import.meta.env.DEV && (
              <>
                <Route path="/local-notes-test" element={<LocalNotesTestPage />} />
                <Route path="/notepad-test" element={<NotepadTestPage />} />
              </>
            )}
            <Route path="/service" element={<ServicePage />} />
            <Route path="/notepad" element={<NotesPopoutPage />} />
            <Route path="*" element={<AgentApp />} />
          </Routes>
        </BrowserRouter>
      </AppContextProvider>
    </ErrorBoundary>
  );
}
